import { put, call, take, fork } from 'redux-saga/effects'
import { courseDeleteService } from '../../api/course'

import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'
import { courseDeleteSuccess } from 'src/reducers/collection/action'
import { COURSE_DELETE } from 'src/reducers/collection/type'

function* assignmentDeleteFlow(payload) {
  try {
    const { id, callback } = payload

    yield call(courseDeleteService, id)
    yield put(courseDeleteSuccess(id))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

export default function* assignmentDeleteWatcher() {
  while (true) {
    const action = yield take(COURSE_DELETE)
    const { payload } = action

    yield fork(generalSaga, assignmentDeleteFlow, payload)
  }
}
